import { fetcher } from '@commenda/utils';
import { ServiceRequestIssueStatus } from '@prisma/client';
import { API_BASE_PATH } from '../constants';

export async function updateServiceRequestIssue(
  issueId: string,
  data: {
    message?: string;
    status: ServiceRequestIssueStatus;
  }
) {
  const res = await fetcher(`${API_BASE_PATH}/issue/${issueId}`, {
    method: 'POST',
    body: data,
  });

  if (!res.ok) return false;

  return true;
}
